module.exports = __webpack_public_path__ + "static/media/wp-normal-success.d6ea3209.webp";